export default {
  label: {
    title: {
      hiddeCard: 'Componente ocultado',
    },
    description: 'Siguiendo las normas de la Ley General de Protección de Datos Personales (LGPD), no es posible ver componentes con datos que expongan la identidad de los autores de las publicaciones. Como este panel está compartido con usuarios invitados, el componente que está agregando ahora será ocultado del compartimiento. Para ver la lista de componentes ocultados, acceda al área de Compartimiento.',
    button: {
      aboutSharing: 'Sobre el compartimiento',
      confirm: 'Entendido',
      cancel: 'Cancelar',
    },
  },
};
